import type { UseInvalidateOptions } from "./validation.type";

import { client } from "@/config/client";
import { useModelMutation } from "@/hooks/queries";

export const useInvalidateModel = (
  model: string,
  id: number,
  options?: UseInvalidateOptions
) => {
  return useModelMutation<null, null>(model, id, {
    ...(options ?? {}),
    mutationFn: () => client[model].invalidate(id),
  });
};
